/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable radix */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Input, InputAdornment, withStyles } from "@material-ui/core";
import Slider from "@material-ui/core/Slider";
import ValueLabel from "@material-ui/core/Slider/ValueLabel";
import FiltersFunnelIcon from "assets/svgs/FiltersFunnelIcon";
import OutlinedSearch from "assets/svgs/OutlinedSearch";
import departmentData from "cms/department-data";
import { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import ChevronRightGreen from "assets/svgs/ChevronRightGreen";
import { numberWithCommas } from "modules/candidate/profile/utils/parsers";
import CrossIcon from "components/RevampFeedDetails/assets/CrossIcon";
import {
	DISTANCE_OPTIONS,
	EDUCATION_OPTIONS,
	ENGLISH_LEVEL_OPTIONS,
	FILTER_LABELS,
	FILTER_LABELS_FEED,
	FilterChoice,
	GENDER_OPTIONS,
} from "components/JobListingPageComponents/FiltersSidebar";
import {
	DISTANCE_DEFAULT_VALUE,
	MIN_EXPERIENCE_DEFAULT_VALUE,
	POSTED_IN_DEFAULT_VALUE,
	VALUE_TO_LABEL_MAPPING,
} from "components/RevampFeedDetails/constants";
import clsx from "clsx";
import { useWindowResize } from "utils/hooks";
import { getKeyByValue, SALARY_SCALE } from "constants/filters";
import { useRouter } from "next/router";
import { isOnboardingComplete, isUserLoggedIn } from "utils";
import FilterCategoryShell from "./components/FilterCategoryShell";
import useJobFeedStore from "../../store";
import PreAppliedFilterCoachMark from "../PreAppliedFilterCoachMark";

const WORK_MODE = [
	{ label: "Work from home", value: "wfh" },
	{ label: "Work from office", value: "wfo" },
	{ label: "Work from field", value: "wff" },
];
const WORK_TYPE = [
	{ label: "Full time", value: "full_time" },
	{ label: "Part time", value: "part_time" },
	{ label: "Internship", value: "internship" },
];
const WORK_SHIFT = [
	{ label: "Day shift", value: "day_shift" },
	{ label: "Night shift", value: "night_shift" },
];
const POSTED_IN_OPTIONS = [
	{ label: "All", value: -1 },
	{ label: "Last 24 hours", value: 24 },
	{ label: "Last 3 days", value: 24 * 3 },
	{ label: "Last 7 days", value: 24 * 7 },
];
const SORT_BY_OPTIONS = [
	{ label: "Relevant", value: "" },
	{ label: "Salary - High to low", value: "-max_salary" },
	{ label: "Date posted - New to Old", value: "-last_updated" },
];

export const MULTI_SELECT_FILTERS = {
	departmentId: "department_id",
	workType: "work_type",
	workMode: "work_mode",
	workShift: "work_shift",
};

const DesktopFilters = ({
	showPreAppliedFilterCoachMark = false,
	setShowPreAppliedFilterCoachMark = () => null,
	isDataLoading = false,
	location,
}) => {
	const router = useRouter();
	const isSearch = router.query.search;

	const {
		filters,
		applyFilter,
		urlDataObject,
		clearAllFilters,
		setExperienceSearchObject,
		appliedFiltersCount,
		appliedFilters,
		resetFiltersLocalState,
		setUrlSearchQuery,
		discoveryTabs,
	} = useJobFeedStore();
	const [showMoreDepartments, setShowMoreDetartments] = useState(false);
	const [filteredDepartmentData, setFilteredDepartmentData] = useState(departmentData);
	const [salarySliderValue, setSalarySliderValue] = useState(0);
	const [experienceSliderValue, setExperienceSliderValue] = useState(
		Number(filters?.min_experience)
	);
	const [showAllAppliedFilters, setShowAllAppliedFilters] = useState(false);
	const [isMobileView] = useWindowResize();
	const showFeaturedFilter = router.query.featured_jobs === "true";
	const finalAppliedFilters = () => {
		const filterToShow = [];
		appliedFilters.forEach((filter) => {
			if (
				!(
					filter.filterType === "department_id" &&
					urlDataObject?.path?.department_id
				) &&
				!(filter.filterType === "gender" && urlDataObject?.path?.gender)
			) {
				filterToShow.push(filter);
			}
		});
		return filterToShow;
	};
	const handleSalaryScale = (value) => SALARY_SCALE[value];

	const handleSalaryLabel = (sal = undefined) => {
		const label = sal >= 0 ? sal : SALARY_SCALE[salarySliderValue];
		if (!label || label === 0) {
			return "₹0";
		}
		if (label < 100000) {
			return `₹${numberWithCommas(label)}`;
		}
		if (label === 100000) {
			return `₹${label / 100000} Lakh`;
		}
		return `₹${label / 100000} Lakhs`;
	};

	const experienceLabel = (value) => {
		if (value === MIN_EXPERIENCE_DEFAULT_VALUE) return "Any";
		if (Number(value) === 0) {
			return "Fresher";
		}
		return value;
	};
	// If value of resetFiltersLocalState changes, reset local filters.
	useEffect(() => {
		setSalarySliderValue(0);
		setExperienceSliderValue(MIN_EXPERIENCE_DEFAULT_VALUE);
	}, [resetFiltersLocalState]);

	useEffect(() => {
		setExperienceSliderValue(Number(filters?.min_experience));
		setSalarySliderValue(getKeyByValue(SALARY_SCALE, Number(filters?.salary)));
	}, [filters]);
	const renderDepartmentList = () => {
		if (Array.isArray(filteredDepartmentData) && filteredDepartmentData.length > 5) {
			const displayedDepartmentList = showMoreDepartments
				? filteredDepartmentData
				: filteredDepartmentData?.slice(0, 5);
			return (
				<>
					<div className="space-y-[8px]">
						{displayedDepartmentList?.map((department) => (
							<div
								className="flex cursor-pointer items-center space-x-[8px] text-sm leading-[20px]"
								key={department.id}
								onClick={() => {
									applyFilter("department_id", department?.id);
								}}
							>
								<input
									type="checkbox"
									key={department.id}
									name="department"
									value={department?.id}
									checked={filters?.department_id?.includes(
										department?.id
									)}
									className="accent-[#1F8268]"
								/>
								<p className="m-0 truncate text-sm leading-[20px] text-[#190A28]">
									{department?.name}
								</p>
							</div>
						))}
					</div>
					<div
						className="mt-3 flex items-center space-x-[4px]"
						onClick={() => setShowMoreDetartments(!showMoreDepartments)}
					>
						<p className="m-0 cursor-pointer text-xs font-semibold leading-[16px] text-[#1F8268]">
							{showMoreDepartments
								? `Show less`
								: `Show ${filteredDepartmentData.length - 5} more`}
						</p>
						<ChevronRightGreen />
					</div>
				</>
			);
		}
		if (Array.isArray(filteredDepartmentData) && filteredDepartmentData.length < 5) {
			return (
				<div className="space-y-[8px]">
					{filteredDepartmentData?.map((department) => (
						<div
							className="flex cursor-pointer items-center space-x-[8px] text-sm leading-[20px]"
							key={department?.id}
							onClick={() => {
								applyFilter("department_id", department?.id);
							}}
						>
							<input
								type="checkbox"
								key={department?.id}
								name="department"
								value={department?.id}
								checked={filters?.department_id?.includes(department?.id)}
								className="accent-[#1F8268]"
							/>
							<p className="m-0 truncate text-sm leading-[20px] text-[#190A28]">
								{department?.name}
							</p>
						</div>
					))}
				</div>
			);
		}

		return null;
	};
	const handleDepartmentSearchInput = (e) => {
		const filteredResults = departmentData?.filter((department) =>
			department?.name?.toLowerCase()?.includes(e?.target?.value?.toLowerCase())
		);

		setFilteredDepartmentData(filteredResults);
	};
	const handleRemoveFilter = (category, value) => {
		if (Object.values(MULTI_SELECT_FILTERS).includes(category)) {
			applyFilter(category, value);
		} else if (
			category === "sort_by" ||
			category === "gender" ||
			category === "english_level" ||
			category === "education_level" ||
			category === "salary" ||
			category === "distance"
		) {
			applyFilter(category, "");
			if (category === "salary") setSalarySliderValue(0);
		} else if (category === "posted_in") {
			applyFilter(category, POSTED_IN_DEFAULT_VALUE);
		} else if (category === "featured_jobs") {
			applyFilter(category, false);
		} else {
			setUrlSearchQuery({
				...urlDataObject.searchQuery,
				min_experience: null,
			});
			applyFilter(category, MIN_EXPERIENCE_DEFAULT_VALUE);
			if (category === "min_experience")
				setExperienceSliderValue(MIN_EXPERIENCE_DEFAULT_VALUE);
			setExperienceSearchObject({});
		}
	};

	const renderFilters = () => {
		const filterLabelList = isSearch ? FILTER_LABELS : FILTER_LABELS_FEED;
		return Object.entries(filterLabelList).map(([filterKey]) => {
			switch (filterKey) {
				case FilterChoice.SORT_BY:
					return (
						discoveryTabs.activeTabId !== 2 && (
							<FilterCategoryShell
								key={filterKey}
								label="Sort By"
								content={
									<div className="space-y-[8px]">
										{SORT_BY_OPTIONS.map((item) => (
											<div
												className="flex  items-start space-x-[8px]"
												key={item.value}
												onClick={() =>
													applyFilter("sort_by", item.value)
												}
											>
												<input
													type="radio"
													key={item.label}
													name="sort_by"
													value={item.value}
													checked={
														filters?.sort_by === item.value
													}
													className="mt-[4px] accent-[#1F8268]"
												/>
												<label
													htmlFor="posted-in-radio-input"
													className="cursor-pointer"
												>
													{item.label}
												</label>
											</div>
										))}
									</div>
								}
								isFilterApplied={!!filters?.sort_by}
								filterCount={1}
							/>
						)
					);
				case FilterChoice.EXPERIENCE:
					return (
						!urlDataObject?.path?.min_experience &&
						urlDataObject?.path?.min_experience !== 0 && (
							<FilterCategoryShell
								key={filterKey}
								label="Experience"
								subLabel="Your work experience"
								content={
									<div className="mb-[28px] space-y-[8px]">
										<p className="m-0 mb-7 text-[#8C8594]" />
										<div className="w-[95%]">
											<div className="relative w-[100%]">
												<CustomSlider
													ValueLabelComponent={CustomValueLabel}
													step={1}
													value={experienceSliderValue}
													valueLabelFormat={experienceLabel(
														experienceSliderValue
													)}
													min={0}
													max={MIN_EXPERIENCE_DEFAULT_VALUE}
													valueLabelDisplay="on"
													onChange={(_, value) =>
														setExperienceSliderValue(value)
													}
													onChangeCommitted={(_, value) => {
														applyFilter(
															"min_experience",
															value === 0
																? value.toString()
																: value
														);
														setExperienceSearchObject({
															display_text:
																VALUE_TO_LABEL_MAPPING
																	?.min_experience?.[
																	value
																],
															experience_input: value,
														});
													}}
												/>

												<div className="absolute bottom-[-12px] left-0 text-[14px] leading-[20px] text-[#827485]">
													0 years
												</div>

												<div className="absolute bottom-[-12px] right-[-5px] text-[14px] leading-[20px] text-[#827485]">
													31 years
												</div>
											</div>
										</div>
									</div>
								}
								isFilterApplied={
									Number(filters?.min_experience) >= 0 &&
									Number(filters?.min_experience) !==
										MIN_EXPERIENCE_DEFAULT_VALUE
								}
								filterCount={1}
							/>
						)
					);
				case FilterChoice.DISTANCE:
					/* 
					Show distance filter options based on feed and search  
						FEED - only render when user is logged in and onboarded
						SEARCH - only redner when search location query is non empty and of type "area"
					*/
					if (
						(!isSearch && isUserLoggedIn() && isOnboardingComplete()) ||
						(isSearch &&
							(router.query?.location_type === "NBArea" ||
								router.query?.location_type === "Area") &&
							router.query?.location_name !== "")
					) {
						return (
							<FilterCategoryShell
								key={filterKey}
								label="Distance"
								content={
									<div className="space-y-[8px]">
										{DISTANCE_OPTIONS.filter((item) =>
											discoveryTabs?.activeTabId === 3
												? item.value !== "lt-20" &&
												  item.value !== "lt-50"
												: true
										).map((item) => (
											<div
												className="flex cursor-pointer items-center space-x-[8px]"
												key={item.value}
												onClick={() => {
													applyFilter("distance", item.value);
												}}
											>
												<input
													type="radio"
													key={item.label}
													name="distance"
													value={item.value}
													checked={
														filters?.distance === item.value
													}
													className="accent-[#1F8268]"
												/>
												<label
													htmlFor="distance-radio-input"
													className="cursor-pointer"
												>
													{item.label}
												</label>
											</div>
										))}
									</div>
								}
								isFilterApplied={
									filters?.distance?.length > 0 &&
									DISTANCE_DEFAULT_VALUE !== filters?.distance
								}
								filterCount={1}
							/>
						);
					}
					return null;
				case FilterChoice.SALARY:
					return (
						<FilterCategoryShell
							key={filterKey}
							label="Salary"
							content={
								<div className="mb-[28px] space-y-[8px]">
									<p className="m-0 mb-7 text-[#8C8594]">
										Minimum monthly salary
									</p>
									<div className="w-[95%]">
										<div className="relative w-[100%]">
											<CustomSlider
												step={1}
												value={salarySliderValue}
												min={1}
												max={16}
												valueLabelDisplay="on"
												ValueLabelComponent={CustomValueLabel}
												onChange={(_, value) =>
													setSalarySliderValue(value)
												}
												onChangeCommitted={(_, value) => {
													applyFilter(
														"salary",
														SALARY_SCALE[value]
													);
												}}
												valueLabelFormat={handleSalaryLabel()}
												scale={handleSalaryScale}
											/>

											<div className="absolute bottom-[-12px] left-0 text-[14px] leading-[20px] text-[#827485]">
												0
											</div>

											<div className="absolute bottom-[-12px] right-[-5px] text-[14px] leading-[20px] text-[#827485]">
												1.5 Lakhs
											</div>
										</div>
									</div>
								</div>
							}
							isFilterApplied={filters?.salary > 0}
							filterCount={1}
						/>
					);
				case FilterChoice.POSTED_IN:
					return (
						<FilterCategoryShell
							key={filterKey}
							label="Date posted"
							content={
								<div className="space-y-[8px]">
									{(discoveryTabs?.activeTabId === 4
										? POSTED_IN_OPTIONS.slice(0, -1)
										: POSTED_IN_OPTIONS
									).map((item) => (
										<div
											className="flex cursor-pointer items-center space-x-[8px]"
											key={item.value}
											onClick={() => {
												applyFilter("posted_in", item.value);
											}}
										>
											<input
												type="radio"
												key={item.label}
												name="postedIn"
												value={item.value}
												checked={
													filters?.posted_in === item.value
												}
												className="accent-[#1F8268]"
											/>
											<label
												htmlFor="posted-in-radio-input"
												className="cursor-pointer"
											>
												{item.label}
											</label>
										</div>
									))}
								</div>
							}
							isFilterApplied={filters?.posted_in > 0}
							filterCount={1}
						/>
					);
				case FilterChoice.EDUCATION:
					return (
						<FilterCategoryShell
							key={filterKey}
							label="Highest education"
							subLabel="Select your highest education level to see all eligible jobs"
							content={
								<div className="space-y-[8px]">
									{EDUCATION_OPTIONS.map((item) => (
										<div
											className="flex cursor-pointer items-center space-x-[8px]"
											key={item.value}
											onClick={() => {
												applyFilter(
													"education_level",
													item.value
												);
											}}
										>
											<input
												type="radio"
												key={item.label}
												name="education_level"
												value={item.value}
												checked={
													filters?.education_level == item.value
												}
												className="accent-[#1F8268]"
											/>
											<label
												htmlFor="education-level-radio-input"
												className="cursor-pointer"
											>
												{item.label}
											</label>
										</div>
									))}
								</div>
							}
							isFilterApplied={Number(filters?.education_level) > 0}
							filterCount={1}
						/>
					);
				case FilterChoice.WORK_MODE:
					return (
						!urlDataObject?.path?.work_mode && (
							<FilterCategoryShell
								key={filterKey}
								label="Work Mode"
								content={
									<div className="space-y-[8px]">
										{WORK_MODE.map((item) => (
											<div
												className="flex cursor-pointer items-center space-x-[8px]"
												onClick={() =>
													applyFilter("work_mode", item?.value)
												}
											>
												<input
													type="checkbox"
													key={item.label}
													name="work_mode"
													value={item.value}
													checked={filters?.work_mode?.includes(
														item.value
													)}
													className="accent-[#1F8268]"
												/>
												<p className="m-0 truncate text-sm leading-[20px] text-[#190A28]">
													{item?.label}
												</p>
											</div>
										))}
									</div>
								}
								isFilterApplied={filters?.work_mode?.length > 0}
								filterCount={filters?.work_mode?.length}
							/>
						)
					);
				case FilterChoice.WORK_TYPE:
					return (
						!urlDataObject?.path?.work_type && (
							<FilterCategoryShell
								key={filterKey}
								label="Work Type"
								content={
									<div className="cursor-pointer space-y-[8px]">
										{WORK_TYPE.map((item) => (
											<div
												className="flex cursor-pointer items-center space-x-[8px]"
												onClick={() =>
													applyFilter("work_type", item.value)
												}
											>
												<input
													type="checkbox"
													key={item.label}
													name="work_type"
													value={item.value}
													checked={filters?.work_type?.includes(
														item.value
													)}
													className="accent-[#1F8268]"
												/>
												<p className="m-0 truncate text-sm leading-[20px] text-[#190A28]">
													{item?.label}
												</p>
											</div>
										))}
									</div>
								}
								isFilterApplied={filters?.work_type?.length > 0}
								filterCount={filters?.work_type?.length}
							/>
						)
					);
				case FilterChoice.WORK_SHIFT:
					return (
						!urlDataObject?.path?.work_shift && (
							<FilterCategoryShell
								key={filterKey}
								label="Work Shift"
								content={
									<div className="space-y-[8px]">
										{WORK_SHIFT.map((item) => (
											<div
												className="flex cursor-pointer items-center space-x-[8px]"
												onClick={() =>
													applyFilter("work_shift", item.value)
												}
											>
												<input
													type="checkbox"
													key={item.label}
													name="work_shift"
													value={item.value}
													checked={filters?.work_shift?.includes(
														item.value
													)}
													className="accent-[#1F8268]"
												/>
												<p className="m-0 truncate text-sm leading-[20px] text-[#190A28]">
													{item?.label}
												</p>
											</div>
										))}
									</div>
								}
								isFilterApplied={filters?.work_shift?.length > 0}
								filterCount={filters?.work_shift?.length}
							/>
						)
					);
				case FilterChoice.DEPARTMENT:
					return (
						!urlDataObject?.path?.department_id && (
							<FilterCategoryShell
								key={filterKey}
								label="Department"
								content={
									<div className="space-y-[12px]">
										<div className="w-full rounded-[8px] border-[1px] bg-[#F4F2F6] px-[8px] py-[4px]">
											<StyledInput
												disableUnderline
												className=" grow outline-none"
												startAdornment={
													<InputAdornment position="start">
														<OutlinedSearch
															height="14"
															width="14"
														/>
													</InputAdornment>
												}
												placeholder="Search"
												onChange={handleDepartmentSearchInput}
											/>
										</div>
										<div>{renderDepartmentList()}</div>
									</div>
								}
								isFilterApplied={filters?.department_id?.length > 0}
								filterCount={filters?.department_id?.length}
							/>
						)
					);
				case FilterChoice.ENGLISH:
					return (
						<FilterCategoryShell
							key={filterKey}
							label="English level"
							subLabel="Select your English level to see all eligible jobs"
							content={
								<div className="space-y-[8px]">
									{ENGLISH_LEVEL_OPTIONS.map((item) => (
										<div
											className="flex cursor-pointer items-center space-x-[8px]"
											key={item.value}
											onClick={() => {
												applyFilter("english_level", item.value);
											}}
										>
											<input
												type="radio"
												key={item.label}
												name="english_level"
												value={item.value}
												checked={
													filters?.english_level === item.value
												}
												className="accent-[#1F8268]"
											/>
											<label
												htmlFor="english-level-radio-input"
												className="cursor-pointer"
											>
												{item.label}
											</label>
										</div>
									))}
								</div>
							}
							isFilterApplied={filters?.english_level !== ""}
							filterCount={1}
						/>
					);
				case FilterChoice.FEATURED:
					if (showFeaturedFilter)
						return (
							<FilterCategoryShell
								key={filterKey}
								label="One-Click Filters"
								content={
									<div className="space-y-[8px]">
										<div
											className="flex cursor-pointer items-center space-x-[8px]"
											onClick={(e) =>
												applyFilter(
													"featured_jobs",
													!filters.featured_jobs
												)
											}
										>
											<input
												type="checkbox"
												key={"Featured Jobs"}
												name="featured_jobs"
												value={filters?.featured_jobs}
												checked={filters?.featured_jobs}
												onChange={(e) =>
													applyFilter(
														"featured_jobs",
														e.target.checked
													)
												}
												className="accent-[#1F8268]"
											/>
											<p className="m-0 truncate text-sm leading-[20px] text-[#190A28]">
												Featured jobs
											</p>
										</div>
									</div>
								}
								isFilterApplied={filters?.featured_jobs}
								filterCount={filters?.featured_jobs ? 1 : 0}
							/>
						);
					return null;

				case FilterChoice.GENDER:
					return (
						<FilterCategoryShell
							key={filterKey}
							label="Gender"
							content={
								<div className="space-y-[8px]">
									{GENDER_OPTIONS.map((item) => (
										<div
											className="flex cursor-pointer items-center space-x-[8px]"
											key={item.value}
											onClick={() => {
												applyFilter("gender", item.value);
											}}
										>
											<input
												type="radio"
												key={item.label}
												name="gender"
												value={item.value}
												checked={filters?.gender === item.value}
												className="accent-[#1F8268]"
											/>
											<label
												htmlFor="gender-radio-input"
												className="cursor-pointer"
											>
												{item.label}
											</label>
										</div>
									))}
								</div>
							}
							isFilterApplied={filters?.gender}
							filterCount={1}
							hideDivider
						/>
					);
				default:
					return null;
			}
		});
	};

	return (
		<div
			data-testid="desktop-filters"
			className={clsx(
				"rounded-xl border border-solid border-[#E8E7EA] bg-white p-[16px] shadow-sm",
				{
					relative: showPreAppliedFilterCoachMark,
					"pointer-events-none": showPreAppliedFilterCoachMark,
				}
			)}
		>
			<div className="space-y-[16px]">
				{/* Section Heading */}
				{!isMobileView && !isDataLoading && (
					<PreAppliedFilterCoachMark
						isOpen={showPreAppliedFilterCoachMark}
						handleClose={() => {
							setShowPreAppliedFilterCoachMark(false);
						}}
					/>
				)}
				<div
					className={clsx({
						"absolute top-0 z-[9999] ml-[-16px] w-[248px] rounded-[12px] bg-[#fff] p-[16px]":
							showPreAppliedFilterCoachMark,
					})}
				>
					<div className="mb-[16px] flex items-center justify-between">
						<div className="flex items-center space-x-[4px]">
							<FiltersFunnelIcon />
							<div className="flex items-center">
								<p className="m-0 text-sm font-semibold leading-[20px]">
									Filters&nbsp;
								</p>
								{/* Applied Filters Count */}
								{appliedFiltersCount > 0 && (
									<p className="m-0 text-sm font-semibold leading-[20px]">
										({appliedFiltersCount})
									</p>
								)}
							</div>
						</div>
						{appliedFiltersCount > 0 && (
							<p
								className={clsx(
									"m-0 cursor-pointer text-xs font-semibold leading-[16px] text-[#1F8268]",
									{
										"opacity-[0.5]": showPreAppliedFilterCoachMark,
									}
								)}
								onClick={clearAllFilters}
							>
								Clear all
							</p>
						)}
					</div>
					{/* Applied Filters */}
					{finalAppliedFilters()?.length > 0 && (
						<div>
							<div className="flex flex-wrap items-center gap-[8px]">
								{showAllAppliedFilters &&
									finalAppliedFilters()?.map((filter) => (
										<div
											className="flex w-max cursor-pointer items-center gap-[4px] rounded-3xl border border-solid border-[#003C96] bg-[#EBF3FE] px-[8px] py-[4px]"
											onClick={() => {
												handleRemoveFilter(
													filter?.filterType,
													filter?.filterValue
												);
											}}
											key={filter?.filterLabel}
										>
											<p className="m-0 max-w-[166px] truncate text-xs leading-[16px] text-[#003C96]">
												{filter?.filterLabel}
											</p>
											<CrossIcon />
										</div>
									))}
								{!showAllAppliedFilters &&
									finalAppliedFilters()
										?.slice(0, 2)
										?.map((filter) => (
											<div
												className="flex w-max cursor-pointer items-center gap-[4px] rounded-3xl border border-solid border-[#003C96] bg-[#EBF3FE] px-[8px] py-[4px]"
												onClick={() => {
													handleRemoveFilter(
														filter?.filterType,
														filter?.filterValue
													);
												}}
												key={filter?.filterLabel}
											>
												<p className="m-0 max-w-[166px] truncate text-xs leading-[16px] text-[#003C96]">
													{filter?.filterLabel}
												</p>
												<CrossIcon />
											</div>
										))}
								{finalAppliedFilters()?.length > 2 && (
									<p
										className={clsx(
											"bottom-0 right-0 m-0 cursor-pointer text-xs font-semibold leading-[16px] text-[#1F8268]",
											{
												"opacity-[0.5]":
													showPreAppliedFilterCoachMark,
											}
										)}
										onClick={() => {
											setShowAllAppliedFilters((s) => !s);
										}}
									>
										Show {showAllAppliedFilters ? " less" : " all"}
									</p>
								)}
							</div>
							{!showPreAppliedFilterCoachMark && (
								<div className="mt-[16px] h-[1px] w-full bg-[#E8E7EA]" />
							)}
						</div>
					)}
				</div>
				<div
					className={clsx("space-y-[12px]", {
						"relative top-[138px]": showPreAppliedFilterCoachMark,
					})}
				>
					{renderFilters()}
				</div>
			</div>
		</div>
	);
};

export default DesktopFilters;

const StyledInput = styled(Input)`
	.MuiInputBase-input {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		::placeholder {
			font-weight: normal !important;
		}
		font-size: 14px;
	}
`;

export const CustomSlider = withStyles({
	thumb: {
		height: 14,
		width: 14,
		backgroundColor: "#00422C",
		border: "1px solid rgba(0, 0, 0, 0.10)",
		"&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
			boxShadow: "inherit",
		},
	},
	rail: {
		height: "6px !important",
		color: "#BDE9DD",
		borderRadius: "5px",
	},
	track: {
		border: "none",
		color: "#00422C !important",
		height: "6px !important",
		borderRadius: "5px",
	},
	valueLabel: {
		padding: 0,
		color: "#fff",
	},
})(Slider);

export const CustomValueLabel = withStyles((theme) => ({
	label: {
		color: "#ffffff",
		backgroundColor: "#00422C",
		borderRadius: "20px",
		padding: "4px 6px",
		width: "36px !important",
		minWidth: "fit-content !important",
		fontSize: "12px",
		display: "flex",
		justifyContent: "center",
		position: "relative",
		margin: "18px 0 0 -16px",
		whiteSpace: "nowrap",

		"&::before": {
			content: "",
			position: "absolute",
			bottom: "-20px",
			left: "50%",
			width: 0,
			height: 0,
			border: "12px solid transparent",
			borderTopColor: "#007bff",
			borderBottom: 0,
			borderLeft: 0,
			marginLeft: "-12px",
		},
	},
}))(ValueLabel);
